import { Commit } from 'vuex';
import { SuiviDevisState } from './state';

export enum DevisActions {
    GET_DEVIS = 'GET_DEVIS',
    NAV_FILTER = 'NAV_FILTER_DEVIS',
    EXPORT_XLS = 'EXPORT_XLS',
    GET_INTERVENTIONS = 'GET_INTERVENTIONS',

}

export interface DevisActionTypes {
    commit: Commit;
    state: SuiviDevisState;
    getters: any;
}
